import { MAIN_PRIZE_CATEGORIES_2026 } from 'constants/PrizeCategories';
import { ADMIN_ENDPOINT } from 'utils/constants';

export const NAVIGATION_CSS_TRANSITION_MILLIS = 300;

export type linkItem = {
  title: string;
  link: string;
  condition?: string;
  counter?: {
    type: 'wins' | 'tokens';
    colour: 'orange' | 'teal';
  };
};

export type actionItem = {
  title: string;
  action: string;
};

export type subpageItem = {
  title: string;
  subpages: linkItem[];
};

export type breakItem = {
  break: boolean;
};

type menuItem = linkItem | actionItem | subpageItem | breakItem;
export type menuItems = menuItem[];

export const isLinkItem = (item: menuItem) => 'link' in item;
export const isActionItem = (item: menuItem) => 'action' in item;
export const isSubpagesItem = (item: menuItem) => 'subpages' in item;
export const isBreakItem = (item: menuItem) => 'break' in item;

export const loggedOutMenu: menuItems = [
  {
    title: 'How it works',
    link: '/how-it-works',
  },
  {
    title: 'Prizes',
    link: '/prizes',
  },
  {
    title: 'Winners',
    link: '/winners',
  },
  {
    title: 'About us',
    link: '/about-us',
  },
  {
    title: 'Our impact',
    link: '/giving-back',
  },
  {
    break: true,
  },
  {
    title: 'FAQ',
    link: '/faq',
  },
  {
    title: 'Help centre',
    link: 'https://daymade.zendesk.com/hc/en-gb',
  },
];

export const prizes: linkItem[] = [
  {
    title: 'All prizes',
    link: '/prizes',
  },
  ...Object.entries(MAIN_PRIZE_CATEGORIES_2026).map((category) => ({
    title: category[1].name,
    link: category[1].href,
  })),
];

export const perks: linkItem[] = [
  {
    title: 'Monthly 10k giveaway',
    link: '/monthly-10k-giveaway',
    condition: 'monthly-10k',
  },
  {
    title: 'Leaderboard',
    link: '/leaderboard',
  },
  {
    title: 'My discounts',
    link: '/my-discounts',
  },
  {
    title: 'Win with friends',
    link: '/referrals',
    // condition: 'referrals',
    condition: 'off',
  },
];

export const aboutUs: linkItem[] = [
  {
    title: 'How it works',
    link: '/how-it-works',
  },
  {
    title: 'Our story',
    link: '/about-us',
  },
  {
    title: 'Our impact',
    link: '/giving-back',
  },
  {
    title: 'Winners',
    link: '/winners',
  },
  {
    title: 'Results',
    link: '/results',
  },
];

export const loggedInMenu: menuItems = [
  {
    title: 'Admin',
    link: `https://${ADMIN_ENDPOINT}`,
    condition: 'admin-only',
  },
  {
    title: 'Dashboard',
    link: '/dashboard',
  },
  {
    title: 'My wins',
    link: '/my-wins',
    counter: {
      type: 'wins',
      colour: 'orange',
    },
  },
  {
    title: 'Token town',
    link: '/token-town',
    counter: {
      type: 'tokens',
      colour: 'teal',
    },
  },
  {
    title: 'Prizes',
    subpages: prizes,
  },
  {
    title: 'Perks',
    subpages: perks,
  },
  {
    title: 'About us',
    subpages: aboutUs,
  },
  {
    break: true,
  },
  {
    title: 'FAQ',
    link: '/faq',
  },
  {
    title: 'Help centre',
    link: 'https://daymade.zendesk.com/hc/en-gb',
  },
  {
    title: 'Log out',
    action: 'logout',
  },
];
